import { FaceTecSDK } from "./core-sdk/FaceTecSDK.js/FaceTecSDK";
import { IFaceTecCredentials } from "./src/interfaces";
import { FacetecConfig } from './FacetecConfig'
type IFaceTecSDK = typeof FaceTecSDK;

const isQoreSDKProduction = ["www.qoreid.com", "dashboard.qoreid.com"].includes(
    window.location.hostname
);

const isQoreSDKStaging =
    "stage-qoreid.verifynow.ng" === window.location.hostname;
export let getQoreIdPrimaryColor = "#417FB2";

class Configuration extends FacetecConfig {
    BaseSitePath = "/qoreid-sdk";
    ApiBaseUrl = isQoreSDKProduction
        ? "https://api.qoreid.com"
        : isQoreSDKStaging
        ? "https://stage-qoreapi.verifynow.ng"
        : "https://dev-qoreapi.verifynow.ng";

    allowedWhiteLabel = false;

    private _qoreIdPrimaryColor = "#417FB2";

    // -------------------------------------
    // REQUIRED
    // The URL to call to process FaceTec SDK Sessions.
    // In Production, you likely will handle network requests elsewhere and without the use of this variable.
    // See https://dev.facetec.com/security-best-practices?link=facetec-server-rest-endpoint-security for more information.
    // NOTE: This field is auto-populated by the FaceTec SDK Configuration Wizard.
    public BaseURL = `${this.ApiBaseUrl}/v1/sdk/biometrics`;


    // Set the feature flag(s)
    public SDKInIFrameFeatureFlag = {
        ac_ziif: "991d6c1c-5e5c-4e32-89c7-1ddfac46572e"
    };
    public currentCustomization = new FaceTecSDK.FaceTecCustomization([
        this.SDKInIFrameFeatureFlag
    ]);

    // -------------------------------------
    // Convenience method to initialize the FaceTec SDK.
    // NOTE: This function is auto-populated by the FaceTec SDK Configuration Wizard based on your UI Customizations you picked in the Configuration Wizard GUI.
    override initializeFromAutogeneratedConfig(
        FaceTecSDK: IFaceTecSDK,
        callback: Function,
        faceTecCredentials: IFaceTecCredentials
    ) {
        this.DeviceKeyIdentifier = faceTecCredentials.deviceKeyIdentifier;
        this.PublicFaceScanEncryptionKey = faceTecCredentials.publicFaceScanEncryptionKey;
        this.PublicFaceScanEncryptionKey = faceTecCredentials.productionKeyText;

        // if (isQoreSDKProduction) {
            FaceTecSDK.initializeInProductionMode(
                faceTecCredentials.productionKeyText,
                faceTecCredentials.deviceKeyIdentifier,
                faceTecCredentials.publicFaceScanEncryptionKey,
                (initializedSuccessfully: boolean) => {
                    callback(initializedSuccessfully);
                }
            );
        // } else {
        //     FaceTecSDK.initializeInDevelopmentMode(
        //         faceTecCredentials.deviceKeyIdentifier,
        //         faceTecCredentials.publicFaceScanEncryptionKey,
        //         (initializedSuccessfully: boolean) => {
        //             callback(initializedSuccessfully);
        //         }
        //     );
        // }
    }

    get qoreIdPrimaryColor(): string {
        return this._qoreIdPrimaryColor;
    }

    set qoreIdPrimaryColor(value: string) {
        this._qoreIdPrimaryColor = value;
    }
}

export const Config = new Configuration();
